import * as React from 'react';
import Grid, { GridProps } from '@material-ui/core/Grid';

export const GridContainer: React.FC<GridProps> = ({ spacing = 3, children, style, ...gridProps }) => (
  <div style={{ flexGrow: 1, padding: spacing * 4, ...style }}>
    <Grid container spacing={spacing} {...gridProps}>
      {children}
    </Grid>
  </div>
);
